export var ButtonOverrides = function (theme) { return ({
    MuiButton: {
        root: {
            // Needed for high contrast mode
            border: "1px solid ".concat(theme.palette.highContrastOnly.main),
            fontSize: theme.typography.button.fontSize,
            fontWeight: theme.typography.fontWeightSemiBold,
            lineHeight: 1.4,
            minHeight: '38px',
            padding: '8px 12px',
            textTransform: undefined,
        },
        contained: {
            boxShadow: undefined,
            backgroundColor: undefined,
            color: undefined,
            '&:hover': {
                backgroundColor: undefined,
                borderColor: undefined,
            },
            '&:active': {
                boxShadow: undefined,
            },
            '&$focusVisible': {
                boxShadow: undefined,
            },
            '&$disabled': {
                boxShadow: undefined,
                border: "1px solid ".concat(theme.palette.type === 'light' ? 'transparent' : theme.palette.border.main),
                backgroundColor: theme.palette.type === 'light' ? theme.palette.background.b4 : 'transparent',
            },
        },
        containedSecondary: {
            color: theme.palette.type === 'light'
                ? theme.palette.secondary.contrastText
                : theme.palette.action.disabledBackground,
            backgroundColor: theme.palette.background.b4,
            '&:hover': {
                backgroundColor: theme.palette.background.b5,
                color: theme.palette.text.primary,
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main,
                },
                '&:active': {
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                    // TODO: verify @media (hover: none) active styles with design
                },
                '&:disabled': {
                    color: theme.palette.text.hint,
                },
            },
            '&:focus': {
                color: theme.palette.text.primary,
                textDecoration: 'none',
            },
        },
        containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.type === 'light' ? theme.palette.background.b9 : theme.palette.background.b8,
            '&:hover': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.background.b10,
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main,
                },
                '&:active': {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    // TODO: verify @media (hover: none) active styles with design
                },
                '&:disabled': {
                    color: theme.palette.text.hint,
                },
            },
            '&:focus': {
                color: theme.palette.primary.contrastText,
                textDecoration: 'none',
            },
        },
        // The focus ring on outline buttons replaces the normal button border.
        // This is different from other button types, where the ring is
        // inset inside the button's area.
        outlined: {
            backgroundColor: 'transparent',
            border: undefined,
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 1,
                left: 1,
                right: 1,
                bottom: 1,
                borderRadius: 'inherit',
                boxShadow: "0 0 0 1px ".concat(theme.palette.primary.main),
            },
            '&:hover, &:focus, &:active': {
                backgroundColor: 'transparent',
                color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.primary.main,
            },
            '&:disabled::before': {
                boxShadow: "0 0 0 2px ".concat(theme.palette.border.main),
            },
            '&$disabled': {
                border: undefined,
            },
        },
        /**
         * These overrides ensure that a <PrimaryButton variant="outlined" /> is visually identical to a
         * default `<OutlineButton>`, whose color palette is based on primary colors.
         */
        outlinedPrimary: {
            border: undefined,
            '&:hover': {
                backgroundColor: 'transparent',
                border: undefined,
            },
        },
        iconSizeMedium: {
            '& > *:first-child': {
                fontSize: undefined,
            },
        },
    },
}); };
//# sourceMappingURL=Button.overrides.js.map